// Centralized chat widget helper
// Triggers the tawktrik chat widget loaded via snippet.js in index.html

export function openChat() {
  // tawktrik widget exposes a global API — try known methods
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:open']);
    return;
  }
  if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
    window.Tawk_API.maximize();
    return;
  }
  // cd360 / tawktrik widget — try clicking the widget button
  const widgetBtn = document.querySelector('[id*="cd360"], [class*="cd360"], [id*="tawk"], [class*="tawk"]');
  if (widgetBtn) {
    widgetBtn.click();
    return;
  }
  // Fallback — dispatch a custom event the widget may listen to
  window.dispatchEvent(new CustomEvent('openChat'));
}
